import { catchCommonErrors } from 'app/actions/commonActionUtils'
import { genericFetchingActionCreator, genericPostingActionCreator, getCookieValue } from 'app/actions/genericActionCreator'

export const getEnterpriseSettings = () => {
    return (dispatch) => {
        dispatch(genericFetchingActionCreator('ENTERPRISE_SETTINGS', 'fetching'))
        fetch(`/lgyhub/api/enterprisesettings`, {
            credentials: 'include',
            method: 'GET'
        }).then((response) => {
            return catchCommonErrors(dispatch, response, 'fetching enterprise settings')
        }).then((responseJson) => {
            if (responseJson.status >= 400) {
                dispatch(genericFetchingActionCreator('ENTERPRISE_SETTINGS', 'error'))
                throw new Error(responseJson.errors[0].message)
            } else {
                dispatch(genericFetchingActionCreator('ENTERPRISE_SETTINGS', 'fetched', { list: responseJson }))
            }
        }).catch((error) => {
            console.error('Enterprise settings not found: ', error)
        })
    }
}

export const updateEnterpriseSetting = (setting) => {
    return (dispatch) => {
        dispatch(genericPostingActionCreator('ENTERPRISE_SETTINGS', 'posting'))
        fetch(`/lgyhub/api/enterprisesettings/${setting.id}`, {
            credentials: 'include',
            method: 'PATCH',
            body: JSON.stringify({
                id: setting.id,
                name: setting.name,
                description: setting.description,
                value: setting.value,
                note: setting.note,
                applicationArea: setting.applicationArea
            }),
            headers: new Headers({
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
            })
        }).then((response) => {
            return catchCommonErrors(dispatch, response, `updating enterprise setting id#${setting.id}`)
        }).then(() => {
            dispatch(genericPostingActionCreator('ENTERPRISE_SETTINGS', 'posted', { success: true, name: setting.description }))
            dispatch(getEnterpriseSettings())
        }).catch((error) => {
            dispatch(genericPostingActionCreator('ENTERPRISE_SETTINGS', 'error'))
            console.error('Error updating enterprise settings: ', error)
        })
    }
}

export const clearMessages = () =>
    (dispatch) => { 
        dispatch(genericPostingActionCreator('ENTERPRISE_SETTINGS', 'init')) 
    }
